import { render } from "./ConfirmacaoModal.vue?vue&type=template&id=313669a1&scoped=true"
import script from "./ConfirmacaoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoModal.vue?vue&type=script&lang=js"

import "./ConfirmacaoModal.vue?vue&type=style&index=0&id=313669a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-313669a1"

export default script